function isAsyncAvailable() {
  try {
    new Function("async () => {}")();
  } catch (error) {
    return false;
  }
  return true;
}

if (isAsyncAvailable()) {
  if (
    sessionStorage.getItem("ptspreview") ||
    location.search.includes("ptspreview")
  ) {
    let search = null;
    if (sessionStorage.getItem("ptspreview")) {
      search = sessionStorage.getItem("ptspreview");
    } else {
      search = location.search;
      sessionStorage.setItem("ptspreview", location.search);
    }

    if (!document.currentScript?.getAttribute("ptspreview") && search) {
      const qs = Object.fromEntries(
        search
          .replace("?", "")
          .split("&")
          .map((v) => v.split("="))
      );
      const script = document.createElement("script");
      script.setAttribute("ptspreview", "true");
      script.setAttribute(
        "src",
        `https://preprod.client.get-potions.com/${qs.ptspreview}/potions.js`
      );
      document.head.append(script);
      throw new Error("Loading preview version...");
    }
  }

  window.potions_temp = { widgets: [] };
}